module.exports = __webpack_public_path__ + "static/grafika8@2x-5cbfe8532b2d5a0182ae4a923f730147.png";